import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import {ThemeService} from './core/services/theme.service';
import {NgxSpinnerComponent} from 'ngx-spinner';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    NgxSpinnerComponent
  ],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  protected readonly title = signal('ksna-ui');

  constructor(private themeService: ThemeService) {
    this.themeService.initTheme();
  }
}
